<div
  class="tracked-fields-container tw-p-4 md:tw-p-6 lg:tw-p-8 tw-bg-gray-50 dark:tw-bg-gray-800 tw-rounded-lg tw-shadow">
  <div *ngIf="!groupedFields.length && ledger" class="tw-text-center tw-py-10">
    <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-text-lg">Loading tracked fields...</p>
  </div>

  <div *ngIf="!ledger" class="tw-text-center tw-py-10">
    <p class="tw-text-red-600 dark:tw-text-red-400 tw-text-lg">
      Ledger information is not available. Cannot display tracked fields.
    </p>
  </div>

  <div *ngIf="groupedFields.length && ledger">
    <app-alert alertType="warning"
      >Only use this page if you know what you're doing - this is an early admin feature.</app-alert
    >
    <h2
      class="tw-text-2xl lg:tw-text-3xl tw-font-semibold tw-mb-3 tw-text-gray-800 dark:tw-text-gray-100">
      Select Fields to Track
    </h2>
    <p class="tw-mb-6 tw-text-gray-600 dark:tw-text-gray-300">
      Select the fields you want to track for this ledger. The changes will be applied upon clicking
      "Update".
    </p>

    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-6">
      <span class="tw-text-gray-600 dark:tw-text-gray-300">Current Version:</span>
      <span
        class="tw-font-mono tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-gray-800 dark:tw-text-gray-200 tw-px-2 tw-py-1 tw-rounded tw-text-sm"
        >{{ currentVersion }}</span
      >
    </div>

    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6">
      <div
        *ngFor="let group of groupedFields"
        class="field-group tw-mb-6 md:tw-mb-0 tw-p-4 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-md tw-flex tw-flex-col">
        <h3 class="tw-text-xl tw-font-medium tw-mb-3 tw-text-gray-700 dark:tw-text-gray-200">
          {{ group.groupName }}
        </h3>
        <div class="tw-space-y-2 tw-flex-grow">
          <div *ngFor="let field of group.fields" class="field-item tw-flex tw-items-center">
            <input
              type="checkbox"
              [id]="'field-' + field.key"
              [name]="field.key"
              [checked]="isSelected(field.key)"
              (change)="toggleFieldSelection(field.key)"
              class="tw-mr-2 tw-h-4 tw-w-4 tw-text-blue-600 tw-border-gray-300 dark:tw-border-gray-600 dark:tw-bg-gray-700 dark:tw-ring-offset-gray-800 focus:tw-ring-blue-500 dark:focus:tw-ring-blue-600 tw-rounded" />
            <label
              [for]="'field-' + field.key"
              class="tw-text-gray-700 dark:tw-text-gray-300"
              >{{ field.displayName }}</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="actions tw-mt-8 tw-text-right">
      <button
        (click)="onUpdate()"
        class="update-button tw-px-6 tw-py-2 tw-bg-blue-600 tw-text-white tw-font-semibold tw-rounded-md hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 dark:tw-bg-blue-500 dark:hover:tw-bg-blue-600 dark:focus:tw-ring-offset-gray-800">
        Update Tracked Fields
      </button>
    </div>
  </div>
</div>
